import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseOptionsRequest } from './models/base-options-request.model';
import { RequestOptions } from './models/request-options.model';
import { ResponseState } from '../pipes/with-loading.pipe';

interface Options {
  params?: HttpParams;
}

@Injectable({
  providedIn: 'root',
})
export class BaseApiService {
  private readonly httpClient = inject(HttpClient);

  public get<T = any>(
    endpointUrl: string,
    requestOptions: RequestOptions = {},
  ): Observable<T | ResponseState<T>> {
    const options = this.getOptions(requestOptions);
    return this.httpClient.get<T>(endpointUrl, options);
  }

  public save<T = any>(
    endPointUrl: string,
    requestBody: any,
    requestOptions: RequestOptions = {},
  ): Observable<T> {
    const options = this.getOptions(requestOptions);
    return this.httpClient.post<T>(endPointUrl, requestBody, options);
  }

  private getOptions({ searchParams }: RequestOptions): Options {
    const options: Options = {};
    const params = searchParams ? this.getSearchParams(searchParams) : null;
    if (params && params.keys().length > 0) {
      options.params = params;
    }

    return options;
  }

  private getSearchParams(baseOptionsRequest: BaseOptionsRequest): HttpParams {
    let params = new HttpParams();

    const unacceptedValues: (number | string | null | undefined)[] = [undefined, '', null];
    for (const prop in baseOptionsRequest) {
      if (!unacceptedValues.includes(baseOptionsRequest[prop])) {
        params = params.set(prop, (baseOptionsRequest[prop] as string | number).toString());
      }
    }
    return params;
  }
}
